import { Button } from "@mui/material";

const CancelButton = ({ label, onClick }) => {
  return (
    <Button
      onClick={onClick}
      variant="contained"
      sx={{
        textTransform: "none",
        color: "#166534",
        backgroundColor: "white",
        "&:hover": {
          color: "#16a34a",
          backgroundColor: "white",
        },
      }}>
      {label}
    </Button>
  );
};

export default CancelButton;
